/**
 * Created by Steve on 2024-04-15.
 */
'use restrict';

var confirmationLogReportCtrl = function ($scope, railApi, $stateParams, $timeout) {

    $scope.results = {};
    $scope.hgForm = null;

    // For Job Publishing Report - opened, closed, active
    $scope.getConfirmationLogReportData = function(hgForm) {
        railApi.get('application_confirmation_logs/get_application_confirmation_report', {
                    'email': hgForm.email
        }).promise.then(function(myData) {
            $scope.logData = myData; 
        });
    }
    
};

module.exports = confirmationLogReportCtrl;